// Thin wrapper preserving the existing `case "faq"` route — delegates
// to the new state-aware RentActFAQ component. Kept as a separate file
// so existing route imports (LandlordPage / TenantPage) don't have to
// change.

import React from "react";
import RentActFAQ from "../common/RentActFAQ";

export default function FaqPage() {
    return <RentActFAQ />;
}
